import { getRayon, getSection } from "../../../../utilities";

export const inputsPropsForModalWindow = {
  ownerLeName: {
    key: "ownerLeName",
    label: "Наименование ЮЛ",
    watch: false,
    type: "text",
    required: true,
    disabled: false,
  },
  ownerAdress: {
    key: "ownerAddress",
    label: "Адрес эксплуатанта базы",
    placeholder:
      "Область или г. Минск, город, район и населенный пункт, улица, номер дома",
    type: "text",
    watch: false,
    required: true,
    disabled: false,
    pattern: {
      value: /^[А-Яа-яЁё0-9\s.,;:!?-]+$/,
      message: `Заполнение на русском языке`,
    },
  },
  ownerPhone: {
    key: "ownerPhone",
    label: "Телефон эксплуатанта базы",
    type: "text",
    watch: false,
    required: true,
    disabled: false,
    pattern: {
      value: /^[0-9+\s,;()-]*$/,
      message: `Введены недопустимые символы`,
    },
  },
  ownerOblast: {
    key: "ownerOblast",
    label: "Область местонахождения базы",
    type: "selectWithSearch",
    watch: true,
    disabled: false,
    searchable: true,
    required: true,
    options: [],
  },
  ownerRayon: {
    key: "ownerRayon",
    label: "Район местонахождения базы",
    type: "selectWithSearch",
    watch: true,
    disabled: true,
    isSearchable: true,
    required: true,
    options: [],
  },
  section: {
    key: "section",
    label: "Участок местонахождения базы",
    type: "selectWithSearch",
    watch: true,
    disabled: true,
    searchable: false,
    required: true,
    options: [],
  },
  location: {
    key: "location",
    label: "Местонахождение базы",
    type: "text",
    disabled: false,
    watch: false,
    required: true,
    pattern: {
      value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
      message: `Заполнение на русском языке`,
    },
  },
  phone1: {
    key: "phone1",
    label: "Основной телефон",
    type: "text",
    disabled: false,
    required: false,
    pattern: {
      value: /^[0-9+\s,;()-]*$/,
      message: `Введены недопустимые символы`,
    },
  },
  phone2: {
    key: "phone2",
    label: "Дополнительный телефон",
    type: "text",
    disabled: false,
    required: false,
    pattern: {
      value: /^[0-9+\s,;()-]*$/,
      message: `Введены недопустимые символы`,
    },
  },
  responPosition: {
    key: "responPosition",
    label: "Должность ответственного за эксплуатацию базы",
    type: "text",
    disabled: false,
    required: true,
    pattern: {
      value: /^[а-яА-ЯёЁ\s.,;:!?-]*$/,
      message: `Заполнение на русском языке`,
    },
  },
  responFio: {
    key: "responFio",
    label: "ФИО ответственного за эксплуатацию базы",
    type: "text",
    disabled: false,
    required: true,
    pattern: {
      value: /^[а-яА-ЯёЁ\s.,;:!?-]*$/,
      message: `Заполнение на русском языке`,
    },
  },
  responDocnum: {
    key: "responDocnum",
    label: "Номер приказа о назначении ответственного за эксплуатацию базы",
    type: "text",
    disabled: false,
    required: false,
  },
  responDocdate: {
    key: "responDocdate",
    label: "Дата приказа о назначении ответственного за эксплуатацию базы",
    type: "date",
    disabled: false,
    required: false,
    customValidation(value) {
      if (new Date(value) > new Date()) {
        return "Дата не может быть позднее текущей";
      } else {
        return true;
      }
    },
  },
  note: {
    key: "note",
    label: "Примечание",
    type: "text",
    disabled: false,
    required: false,
  },
  ownerUnp: {
    key: "ownerUnp",
    label: "УНП",
    type: "text",
    placeholder: "Введите",
    fieldModeView: false,
    disabled: false,
    required: true,
    needInForm: true,
    maxLength: 9,
    pattern: {
      value: /^[0-9]+[0-9]*$/,
      message: `Введите только цифры`,
    },
  },
};
export const optionsButton = {
  add: "Добавить новую базу",
  edit: "Редактировать запись",
  view: "Просмотр записи",
};
export const setInputsPropsForModalWindow = async (typeField, props, type) => {
  if (type === "add") {
    inputsPropsForModalWindow.ownerLeName.required = true;
    inputsPropsForModalWindow.ownerUnp.required = true;
  } else {
    inputsPropsForModalWindow.ownerLeName.disabled = true;
    inputsPropsForModalWindow.ownerUnp.disabled = true;
    inputsPropsForModalWindow.ownerLeName.required = false;
    inputsPropsForModalWindow.ownerUnp.required = false;
  }
  switch (typeField) {
    case "firstInit": {
      inputsPropsForModalWindow.ownerOblast.options = props.ownerOblast;
      inputsPropsForModalWindow.ownerRayon.options = [];
      inputsPropsForModalWindow.ownerRayon.disabled = true;
      inputsPropsForModalWindow.section.options = [];
      inputsPropsForModalWindow.section.disabled = true;
      inputsPropsForModalWindow.ownerLeName.disabled = false;
      inputsPropsForModalWindow.ownerUnp.disabled = false;
      break;
    }
    case "ownerOblast": {
      inputsPropsForModalWindow.ownerRayon.options = await getRayon(props);
      inputsPropsForModalWindow.ownerRayon.options =
        inputsPropsForModalWindow.ownerRayon.options.map((el) => {
          return { ...el, key: "ownerRayon" };
        });
      inputsPropsForModalWindow.ownerRayon.disabled = !Boolean(
        inputsPropsForModalWindow.ownerRayon.options.length,
      );
      inputsPropsForModalWindow.section.options = [];
      inputsPropsForModalWindow.section.disabled = true;
      break;
    }
    case "ownerRayon": {
      inputsPropsForModalWindow.section.options = await getSection(props);
      inputsPropsForModalWindow.section.disabled = !Boolean(
        inputsPropsForModalWindow.section.options.length,
      );
      break;
    }
    default:
      break;
  }
};
export const getInputsPropsForModalWindow = () => inputsPropsForModalWindow;
